import React from "react"
import { Link } from "gatsby"
import { css } from "@emotion/core"

// import PrettyImage from "../components/pretty-image"

const gradientText = css`
  background: var(--color-accent-gradient);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
`
const smallMargin = css`
  margin-bottom: 12px;
`

function NextPreviousCard(props) {
  return (
    <article
      css={css`
        position: relative;
        margin-top: 60px;
        &:hover {
          & h3 {
            color: var(--color-interactive-light);
            transition: all 100ms linear;
            -webkit-transition: all 100ms linear;
          }
        }
      `}
    >
      <Link
        css={css`
          position: relative;
          display: flex;
          text-decoration: none;
          color: var(--color-text);
          // height: 450px;
          // overflow: hidden;
        `}
        to={props.node.fields.slug}
      >
        <div
          css={css`
            // position: relative;
            // top: 30%;
            // width: 100%;
            background: var(--color-primary);
            padding: 15px;
            padding-top: 30px;
          `}
        >
          <h6
              css={css`
                position: absolute;
                top: 10px;
                right 10px;
                letter-spacing: 1.3px;
              `}
            >
              {props.node.frontmatter.date}
            </h6>
            <h4
              css={css`
                position: absolute;
                top: -10px;
                left 15px;
                color: var(--color-text-negative);
                background: var(--color-interactive-dark);
                padding: 5px 10px;
              `}
            >
              {props.previous ? "PREVIOUS:" : "NEXT:"}
            </h4>
          <div
            css={css`
              position: relative;
              // top: 15%;
              // height: 200px;
              overflow: hidden;
            `}
          >
            <h3
              css={css`
                ${smallMargin};
              `}
            >
              {props.node.frontmatter.title}
            </h3>
            <h4
              css={css`
                ${gradientText};
                ${smallMargin};
              `}
            >
              {props.node.frontmatter.description}
            </h4>
            <p css={css``}>{props.node.excerpt}</p>
          </div>
        </div>
      </Link>
    </article>
  )
}

export default NextPreviousCard